import { render } from "./AboutModal.vue?vue&type=template&id=120b3a70&scoped=true"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"

import "./AboutModal.vue?vue&type=style&index=0&id=120b3a70&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120b3a70"]])

export default __exports__